export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/auth_check.worker.362ca451.worker.js");
}
